module.exports = __webpack_public_path__ + "img/gunter_Logo-bg.4ba7262f.png";